import { useEffect } from "react";
import { useLanguage } from "../../LanguageContext";
import translations from "../../Translations/translation.json";
import "./PageNotFound.css";

const PageNotFound = () => {
  const { language } = useLanguage();

  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translations[language]) ||
      key
    );
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="page-not-found-css">
      <div className="container pt-3">
        <h1 className="text-6xl font-bold mb-4">
          {/* Page Not Found */}
          {translate("pageNotFoundTitle")}
        </h1>
        <p className="text-xl">
          {translate("pageNotFoundDesc")}{" "}
          {/* Sorry, we couldn’t find the page you’re looking for. */}
        </p>
        <a href="/" className="">
          {translate("goHome")} {/* Go Home */}
        </a>
        <img
          src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1758623130/Group_278_1_lwpfpd.png"
          align="right"
        />
      </div>
    </div>
  );
};

export default PageNotFound;
